import Vue from 'vue'
import promptConfig from './prompt.vue'

function prompt(msg,call) {
    let promptTpl = Vue.extend(promptConfig);
    let promptPro = new promptTpl({
        el:document.createElement('div')
    });
    document.body.appendChild(promptPro.$el);
    promptPro.$watch('promptShow',function (val) {
        if(!val){
            promptPro.$destroy(true);
            promptPro.$el.parentNode.removeChild(promptPro.$el)
        }
    });
    promptPro.message = msg;
    promptPro.promptShow = true;
    promptPro.callBack = call;
}
export default prompt



// WEBPACK FOOTER //
// ./src/components/prompt/prompt.js